import { initializeApp } from "firebase/app";
import { getAnalytics, isSupported } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCraBhPSm_IkLzTa79UL6e1uW9MP1i3poM",
  authDomain: "htxhomesolutions-3ffda.firebaseapp.com",
  projectId: "htxhomesolutions-3ffda",
  storageBucket: "htxhomesolutions-3ffda.firebasestorage.app",
  messagingSenderId: "1035315974526",
  appId: "1:1035315974526:web:d9ac3de33e45184b22632f",
  measurementId: "G-KZHHP7ZJ4F",
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

isSupported().then((yes) => {
  if (yes) getAnalytics(app);
});

export { app, db };